import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService, ZVOOVE_CUSTOMER_SUCCESS_ROLE, ZVOOVE_SUPER_ADMIN_ROLE } from '@zvoove-market/shared';

export const customerSuccessAreaRedirectGuard = (): CanActivateFn => (): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return (
    (authService.$context().globalRoles.includes(ZVOOVE_CUSTOMER_SUCCESS_ROLE) && router.parseUrl('/customer-support/customers')) ||
    (authService.$context().globalRoles.includes(ZVOOVE_SUPER_ADMIN_ROLE) && router.parseUrl('/customer-support/users')) ||
    router.parseUrl('/not-found')
  );
};
